import { render, staticRenderFns } from "./plats.vue?vue&type=template&id=541067dc&scoped=true&"
import script from "./plats.vue?vue&type=script&lang=js&"
export * from "./plats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541067dc",
  null
  
)

export default component.exports